module.exports = __webpack_public_path__ + "img/general-active.95302f67.svg";